import { render } from "./CustomhousePageList.vue?vue&type=template&id=0783bbf8&scoped=true&ts=true"
import script from "./CustomhousePageList.vue?vue&type=script&lang=ts"
export * from "./CustomhousePageList.vue?vue&type=script&lang=ts"

import "./CustomhousePageList.vue?vue&type=style&index=0&id=0783bbf8&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0783bbf8"]])

export default __exports__